import React, { useEffect, useState } from 'react';
import { auth, userApi, invalidSession } from '@/lib/api';

export default function SessionHandoff() {
  const [error, setError] = useState('');
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const origin = params.get('origin'), challenge = params.get('challenge'), state = params.get('state');
    const allowed = ['https://amwali-plus-qhhrqdetwq-uc.a.run.app', 'https://amwaliplus.mahmoud7.com'];
    if (['localhost', '127.0.0.1'].includes(window.location.hostname)) allowed.push('http://localhost:3001', 'http://127.0.0.1:3001');
    if (!allowed.includes(origin) || !/^[A-Za-z0-9_-]{43}$/.test(challenge || '') || !/^[A-Za-z0-9_-]{43}$/.test(state || '')) { setError('رابط الدخول غير صالح.'); return; }
    const finish = values => window.location.replace(`${origin}/#${new URLSearchParams({ ...values, state })}`);
    if (!auth.getUser()) { finish({ error: 'no_session' }); return; }
    userApi.post('/auth/handoff', { origin, challenge }).then(({ data }) => finish({ code: data.code }))
      .catch(failure => { if (invalidSession(failure)) finish({ error: 'no_session' }); else setError('تعذر الاتصال. أعد المحاولة.'); });
  }, []);
  return <main dir="rtl" className="min-h-screen grid place-items-center">{error || 'جارٍ فتح أموالي +…'}</main>;
}
